<template>
    <div>
        <div class="d-flex justify-content-around align-items-center">
            <div>
                <div class="span">{{ totalAnswered }}</div>
                <span class="legend">{{ $t('enps.answers') }}</span>
            </div>
            <div>
                <div class="span">{{ totalAnsweredPercent }}%</div>
                <span class="legend">{{ $t('enps.report.totalNumberOfEmployees') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AdditionalInformation',
    props: {
        totalAnsweredPercent: 0,
        totalAnswered: 0,
        enpsAvegare: 0,
    },
}
</script>
<style lang="scss" scoped>
.span {
    font-family: 'Roboto';
    font-weight: bold;
    font-size: 40px;
    align-items: center;
    text-align: center;
    color: #3b3f4e;
}
.legend {
    font-size: 20px;
    align-items: center;
    text-align: center;
    color: #3b3f4e;
}
@media screen and (max-width: 930px) {
    .legend {
        font-size: 9px;
    }
    .span {
        font-size: 19px;
    }
}

@media screen and (max-width: 1200px) {
    .legend {
        font-size: 14px;
    }
    .span {
        font-size: 28px;
    }
}
</style>
